<template>
  <div class="card">
    <div class="card-body">
      <h5 class="mb-4">
        <strong>Tambah Video Vertical Baru</strong>
      </h5>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          label="Judul Video"
        >
          <a-input
            :disabled="submitting"
            placeholder="Masukkan Judul Video"
            v-decorator="[
              'title',
              {
                rules: [
                  { required: true, message: 'Judul Video harus diisi!' },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          label="Deskripsi Video"
        >
          <a-input
            :disabled="submitting"
            placeholder="Masukkan Deskripsi Video"
            v-decorator="[
              'description',
              {
                rules: [
                  { required: true, message: 'Deskripsi Video harus diisi!' },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          label="Thumbnail"
        >
          <a-upload
            :action="uploadThumbnail"
            name="upload"
            :file-list="fileListThumb"
            @change="handleChangeThumb"
            v-decorator="[
              'thumbnail',
              {
                valuePropName: 'upload',
                rules: [{ required: true, message: 'Thumbnail harus diisi!' }],
              },
            ]"
          >
            <a-button> <a-icon type="upload" /> Click to Upload </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          label="Video"
        >
          <a-upload
            :action="uploadVideo"
            name="upload"
            :file-list="fileListVideo"
            @change="handleChangeVideo"
            v-decorator="[
              'urlVideo',
              {
                valuePropName: 'upload',
                rules: [{ required: true, message: 'Video harus diisi!' }],
              },
            ]"
          >
            <a-button> <a-icon type="upload" /> Click to Upload </a-button>
          </a-upload>
        </a-form-item>
        <a-button
          html-type="submit"
          :disabled="submitting"
          class="mr-3 btn btn-success"
        >
          Simpan Data
        </a-button>
        <a-button class="mr-3" type="danger">Hapus Data</a-button>
        <a-button class="btn btn-secondary" @click="$router.push('/video')"
          >Kembali</a-button
        >
      </a-form>
    </div>
  </div>
</template>

<script>
import { notification } from 'ant-design-vue'
import { BASE_URL } from '../../../config'
import apiClient from '../../../services/axios'
import { uniqueId } from 'lodash'

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      uploadThumbnail: `${BASE_URL}/upload/video-vertical/thumbnail`,
      uploadVideo: `${BASE_URL}/upload/video-vertical`,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      fileListThumb: [],
      fileListVideo: [],
      urlThumbnail: null,
      urlVideo: null,
      submitting: false,
    }
  },
  created() {
    this.getInitialData()
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        console.log('Received values of form: ', values, '\n', err)
        if (!err) {
          values.urlVideo = this.urlVideo
          values.thumbnail = this.urlThumbnail
          this.submitting = true
          console.log('Received values of form: ', values)
          try {
            const res = await apiClient.post('/videoVertical', values)
            // console.log(res, '<<<')
            if (res && res.data) {
              notification.success({
                message: 'Sukses',
                description: 'Data berhasil ditambahkan',
                duration: 5,
              })
              this.$router.push('/video')
            }
            this.submitting = false
          } catch (e) {
            this.submitting = false
          }
        }
      })
    },
    async getInitialData() {
      const res = await apiClient.get('/videoVertical/' + this.$route.params.id)
      if (res.data) {
        // this.form.getFieldDecorator('title', {
        //   initialValue: 'tetisitlinglsnk',
        // })
        if (res.data.thumbnail) {
          this.fileListThumb.push({
            uid: uniqueId(),
            name: res.data.thumbnail.split('/').at(-1),
            url: `${BASE_URL}${res.data.thumbnail}`,
          })
          this.form.setFieldsValue({ thumbnail: res.data.thumbnail })
        }
        if (res.data.url) {
          this.fileListVideo.push({
            uid: uniqueId(),
            name: res.data.url.split('/')[res.data.url.split('/').length - 1],
            url: `${BASE_URL}${res.data.url}`,
          })
          this.form.setFieldsValue({ urlVideo: res.data.url })
        }
        this.form.setFieldsValue({ title: res.data.title })
        this.form.setFieldsValue({ description: res.data.description })
      }
      console.log(res, '<<<<<')
    },
    handleChangeThumb(info) {
      // this.loadingUpload = true
      let fileList = [...info.fileList]

      fileList = fileList.map((file) => {
        if (file.response) {
          this.urlThumbnail = file.response.data
          file.url = file.response.url
          file.path = file.response.path
          file.file = file.response._id
        }
        return file
      })
      if (fileList.length > 10) {
        fileList = fileList.slice(-10)
      }
      this.fileListThumb = fileList
      //   if (!info.event) {
      //     this.loadingUpload = false
      //   }
    },
    handleChangeVideo(info) {
      // this.loadingUpload = true
      let fileList = [...info.fileList]

      fileList = fileList.map((file) => {
        if (file.response) {
          this.urlVideo = file.response.data
          file.url = file.response.url
          file.path = file.response.path
          file.file = file.response._id
        }
        return file
      })
      if (fileList.length > 10) {
        fileList = fileList.slice(-10)
      }
      this.fileListVideo = fileList
      //   if (!info.event) {
      //     this.loadingUpload = false
      //   }
    },
  },
}
</script>

<style lang="scss" module></style>
